module.exports = __webpack_public_path__ + "static/media/1.4.ea7f41eb.zip";